export class AddActivityToFavoritesInput {

    activityId: Number;
    userId: Number;
    confirmAdd: boolean;
}
